// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Barlow-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Barlow-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Barlow-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Barlow-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/icons/Group285.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "BarlowBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "BarlowSemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "BarlowRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
h1 {
  font-family: "Barlow" !important;
  font-size: 38px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

h2 {
  font-family: "Barlow" !important;
  font-size: 34px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

h3 {
  font-family: "BarlowBold" !important;
  font-size: 26px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: normal !important;
}

h4 {
  font-family: "BarlowBold" !important;
  font-size: 22px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: normal !important;
}

h5 {
  font-family: "BarlowSemiBold" !important;
  font-size: 18px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}

p {
  font-family: "BarlowRegular" !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}

.mt-32 {
  margin-top: 32px !important;
}

.mt-24 {
  margin-top: 24px !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mt-16 {
  margin-top: 16px !important;
}

.ml-16 {
  margin-left: 16px !important;
}

.px-20 {
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.bl {
  border-right: 1px solid #EAEAEA;
}

.mt-12 {
  margin-top: 12px !important;
}

.mt-10 {
  margin-top: 10px;
}

.pr-5 {
  padding-right: 5px;
}

.mr-8 {
  margin-right: 8px !important;
}

.ml-8 {
  margin-left: 8px !important;
}

.ml-10 {
  margin-left: 10px;
}

.cta-qte {
  background-color: rgba(0, 0, 0, 0.06) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
  min-width: 60px !important;
}

.counter .MuiFormControl-root {
  width: 15% !important;
}
.counter .MuiInputBase-root {
  border-top-left-radius: 0px !important;
  border-radius: 0px !important;
}

.totale {
  font-size: 16px;
  font-family: "Barlow";
  font-weight: 600;
  color: rgb(18, 16, 16);
}

.input-aug {
  border-bottom: 1px solid #121010;
}

.input-aug div:hover {
  background-color: rgba(228, 1, 21, 0.1) !important;
  border-bottom: 1px solid #FB263B !important;
}

.input-aug:focus-within {
  background-color: rgba(228, 1, 21, 0.24) !important;
  border-bottom: 1px solid #FB263B !important;
}

.css-2y464i-MuiInputBase-root-MuiFilledInput-root:after, .input-aug div::after, .input-aug div::before {
  border-bottom: none !important;
}

.input-aug-filled {
  border-bottom: 1px solid #FB263B !important;
}

.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:after,
.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:before,
.css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root:after,
.css-1tzgnuz-MuiInputBase-root-MuiFilledInput-root:after {
  border-bottom: none !important;
}

.css-2y464i-MuiInputBase-root-MuiFilledInput-root:hover, .css-1tzgnuz-MuiInputBase-root-MuiFilledInput-root:hover {
  background-color: transparent !important;
}

.css-1tzgnuz-MuiInputBase-root-MuiFilledInput-root:hover:not(.Mui-disabled, .Mui-error):before {
  border-bottom: none !important;
}

.css-2y464i-MuiInputBase-root-MuiFilledInput-root:hover:not(.Mui-disabled, .Mui-error):before {
  border-bottom: none !important;
}

.css-10botns-MuiInputBase-input-MuiFilledInput-input, select, .input-aug div:before {
  border-bottom: 1px solid #121010 !important;
}

.css-10botns-MuiInputBase-input-MuiFilledInput-input:hover, .css-10botns-MuiInputBase-input-MuiFilledInput-input:focus, .css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root:focus,
.css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root.Mui-focused {
  border-bottom: 1px solid #FB263B !important;
}

.Mui-selected {
  background-color: rgb(251, 38, 59) !important;
  color: white !important;
  pointer-events: none !important;
}

.MuiMenuItem-root:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: rgb(253, 230, 232) !important;
}

.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:hover {
  background-color: transparent !important;
}

.float-right {
  float: right;
}

.error-text, .error {
  color: #FF8A00;
  padding-top: 5px;
}

hr {
  color: rgb(234, 234, 234) !important;
}

.cta-retour {
  text-decoration: none !important;
  font-size: 16px;
  font-family: "Barlow";
  font-weight: 600;
  color: #FB263B;
}

.cta-retour:hover {
  text-decoration: none !important;
  font-size: 16px;
  font-family: "Barlow";
  font-weight: 600;
  color: #ED4E5C;
}

.cta-retour:focus {
  text-decoration: none !important;
  font-size: 16px;
  font-family: "Barlow";
  font-weight: 600;
  color: #F499A1;
}

.border-adresse {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  padding: 15px;
  border-radius: 5px;
}

.min-vh-80 {
  min-height: 80vh;
}

.mt-48 {
  margin-top: 48px !important;
}

.open, .rotate180 {
  transform: rotate(-180deg);
}

.fitContent {
  width: fit-content !important;
}

.d-column {
  flex-direction: column !important;
}

.label-sort svg {
  display: none !important;
}

.w-54 {
  width: 54px !important;
}

.right-aj {
  display: inline-flex;
  justify-content: right;
  align-items: baseline;
}

a {
  text-decoration: none !important;
}

.table-photo {
  width: 75px;
  height: 75px;
  border: 1px solid lightgray;
  border-radius: 50%;
  margin: 5px;
}

.cfvlby {
  background-color: unset !important;
  color: white;
}

.rdt_TableHead {
  background: #2D2A2C;
}

.action svg {
  color: #FB263B;
  margin-right: 15px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.action svg:hover {
  opacity: 0.7;
}

.action {
  display: flex;
}

.dropzone {
  width: 100%;
  min-height: 250px;
  background: whitesmoke;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px dashed gray;
}

.cadre svg {
  position: absolute;
  cursor: pointer;
  color: #fb263b;
}

.MuiListItem-root {
  cursor: pointer;
}

.MuiTable-root {
  overflow-y: auto;
}

.text-ref {
  font-size: 14px !important;
  font-family: "Barlow" !important;
  font-weight: 400 !important;
  color: rgb(125, 119, 121) !important;
}

.ml-16 {
  margin-left: 16px !important;
}

.css-15v22id-MuiAccordionDetails-root {
  padding: 0px !important;
}

.aug-table td {
  padding: 0px 10px !important;
}

.aug-table th {
  padding: 10px !important;
}

.lang-select {
  background: transparent;
  border: none;
  border-bottom: none !important;
  color: white;
  font-size: 18px;
  font-family: "Barlow";
  font-weight: 600;
  border: none !important;
}

.btn-primary {
  background-color: #FB263B;
  border: 1px solid #FB263B;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  font-family: "BarlowRegular";
  font-weight: 600;
  text-align: center;
}

.btn-primary:not(:disabled):hover {
  background-color: #ED4E5C;
  border: 1px solid #ED4E5C;
}

.btn-primary:not(:disabled):focus {
  background-color: #F499A1;
  border: 1px solid #F499A1;
}

.btn-secondary {
  background-color: transparent;
  border: 1px solid #FB263B;
  color: #FB263B;
  padding: 10px;
  font-size: 16px;
  font-family: "BarlowRegular";
  font-weight: 600;
  text-align: center;
}

.btn-secondary:not(:disabled):hover {
  background-color: transparent;
  border: 1px solid #ED4E5C;
  color: #ED4E5C;
}

.btn-secondary:not(:disabled):focus {
  background-color: transparent;
  border: 1px solid #F499A1;
  color: #F499A1;
}

.cta {
  color: #FB263B;
  background-color: transparent !important;
  border: none !important;
  text-align: center;
  font-family: "BarlowRegular";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: underline !important;
}

.cta:hover {
  color: #ED4E5C;
}

.cta:focus {
  color: #F499A1;
}

button:disabled {
  background-color: rgb(204, 205, 206); /* Light grey */
  border-color: rgb(204, 205, 206) !important;
  color: #fff; /* Dark grey */
  cursor: not-allowed;
}

.cta:disabled {
  color: rgb(204, 205, 206) !important;
}

button:disabled {
  background-color: rgb(204, 205, 206); /* Light grey */
  border-color: rgb(204, 205, 206) !important;
  color: #fff; /* Dark grey */
  cursor: not-allowed;
}

.left {
  background-color: #2D2A2C;
  margin: 48px !important;
  min-height: 90vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
}

.right {
  min-height: 100vh;
  position: relative;
}

.bloc {
  width: 67%;
  margin: auto;
  padding-top: 10%;
}

.form-login {
  margin: auto;
  padding: 100px;
  width: 90%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.password-field {
  display: flex;
  flex-direction: column;
}

.password-input-container {
  display: flex;
  align-items: center;
  position: relative;
}

.password-input-container input {
  flex-grow: 1;
}

.password-input-container .password-icon {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .form-login {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ui.scss","webpack://./src/views/login/login.scss","webpack://./src/assets/styles/colors.scss","webpack://./src/assets/styles/btn.scss"],"names":[],"mappings":"AACA;EACI,qBAAA;EACA,4CAAA;ACAJ;ADEE;EACE,yBAAA;EACA,4CAAA;ACAJ;ADEE;EACE,6BAAA;EACA,4CAAA;ACAJ;ADEE;EACE,4BAAA;EACA,4CAAA;ACAJ;ADEA;EACI,gCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;ACAJ;;ADEA;EACI,gCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;ACCJ;;ADCA;EACI,oCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;ACEJ;;ADAA;EACI,oCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;ACGJ;;ADDA;EACI,wCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;ACIJ;;ADFA;EACI,uCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;ACKJ;;ADHA;EACI,2BAAA;ACMJ;;ADJA;EACI,2BAAA;ACOJ;;ADLA;EACI,2BAAA;ACQJ;;ADNA;EACI,2BAAA;ACSJ;;ADPA;EACI,4BAAA;ACUJ;;ADRA;EACI,8BAAA;EACA,6BAAA;ACWJ;;ADTA;EACI,+BAAA;ACYJ;;ADVA;EACI,2BAAA;ACaJ;;ADXA;EACI,gBAAA;ACcJ;;ADZA;EACI,kBAAA;ACeJ;;ADbA;EACI,4BAAA;ACgBJ;;ADdA;EACI,2BAAA;ACiBJ;;ADfA;EACI,iBAAA;ACkBJ;;ADhBA;EACI,gDAAA;EACA,4CAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;ACmBJ;;ADfI;EACK,qBAAA;ACkBT;ADhBI;EACI,sCAAA;EACA,6BAAA;ACkBR;;ADfA;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;ACkBJ;;ADhBA;EAEI,gCAAA;ACkBJ;;ADTA;EACI,kDAAA;EACA,2CAAA;ACYJ;;ADTA;EACI,mDAAA;EACA,2CAAA;ACYJ;;ADNA;EACI,8BAAA;ACSJ;;ADPA;EACI,2CAAA;ACUJ;;ADJA;;;;EAII,8BAAA;ACOJ;;ADLA;EACI,wCAAA;ACQJ;;ADNA;EACI,8BAAA;ACSJ;;ADPA;EACI,8BAAA;ACUJ;;ADRA;EACI,2CAAA;ACWJ;;ADTA;;EAEI,2CAAA;ACYJ;;ADTA;EACI,6CAAA;EACA,uBAAA;EACA,+BAAA;ACYJ;;ADVA;EACI,6BAAA;EACA,qBAAA;EACA,+CAAA;ACaJ;;ADXA;EACI,wCAAA;ACcJ;;ADXA;EACI,YAAA;ACcJ;;ADZA;EACI,cE3LG;EF4LH,gBAAA;ACeJ;;ADbA;EACI,oCAAA;ACgBJ;;ADbA;EACI,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cElNY;ADkOhB;;ADdA;EACI,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cExNkB;ADyOtB;;ADfA;EACI,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cE9NkB;ADgPtB;;ADhBA;EACI,uFAAA;EACA,aAAA;EACA,kBAAA;ACmBJ;;ADjBA;EACI,gBAAA;ACoBJ;;ADlBA;EACI,2BAAA;ACqBJ;;ADnBA;EACI,0BAAA;ACsBJ;;ADpBA;EACI,6BAAA;ACuBJ;;ADrBA;EACI,iCAAA;ACwBJ;;ADtBA;EACI,wBAAA;ACyBJ;;ADvBA;EACI,sBAAA;AC0BJ;;ADxBA;EACI,oBAAA;EACA,sBAAA;EACA,qBAAA;AC2BJ;;ADzBA;EACI,gCAAA;AC4BJ;;AD1BA;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;AC6BJ;;AD1BA;EACI,kCAAA;EACA,YAAA;AC6BJ;;AD3BA;EACI,mBAAA;AC8BJ;;AD5BA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AC+BJ;;AD7BA;EACI,YAAA;ACgCJ;;AD9BA;EACI,aAAA;ACiCJ;;AD/BA;EACI,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;ACkCJ;;ADhCA;EACI,kBAAA;EACA,eAAA;EACA,cAAA;ACmCJ;;ADjCA;EACI,eAAA;ACoCJ;;AD9BC;EACG,gBAAA;ACiCJ;;AD/BC;EACG,0BAAA;EACA,gCAAA;EACA,2BAAA;EACA,oCAAA;ACkCJ;;ADhCC;EACG,4BAAA;ACmCJ;;ADjCC;EACG,uBAAA;ACoCJ;;ADlCC;EACG,4BAAA;ACqCJ;;ADnCC;EACG,wBAAA;ACsCJ;;ADpCC;EACG,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;ACuCJ;;AExXA;EACI,yBDHY;ECIZ,yBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AF2XJ;;AEzXA;EACI,yBDZkB;ECalB,yBAAA;AF4XJ;;AEzXA;EACI,yBDhBkB;ECiBlB,yBAAA;AF4XJ;;AEzXA;EACI,6BAAA;EACA,yBAAA;EACA,cDzBY;EC0BZ,aAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AF4XJ;;AE1XA;EACI,6BAAA;EACA,yBAAA;EACA,cDlCkB;AD+ZtB;;AE1XA;EACI,6BAAA;EACA,yBAAA;EACA,cDvCkB;ADoatB;;AE1XA;EACI,cD7CY;EC8CZ,wCAAA;EACA,uBAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;AF6XJ;;AE3XA;EACI,cDxDkB;ADsbtB;;AE5XA;EACI,cD1DkB;ADybtB;;AE7XA;EACI,oCAAA,EAAA,eAAA;EACA,2CAAA;EACA,WAAA,EAAA,cAAA;EACA,mBAAA;AFgYJ;;AE9XE;EACE,oCAAA;AFiYJ;;AE/XE;EACE,oCAAA,EAAA,eAAA;EACA,2CAAA;EACA,WAAA,EAAA,cAAA;EACA,mBAAA;AFkYJ;;AA7bA;EACI,yBAPK;EAQL,uBAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;AAgcJ;;AA9bA;EACI,iBAAA;EACA,kBAAA;AAicJ;;AA/bA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;AAkcJ;;AA/bA;EACI,YAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAkcJ;;AA9bA;EACI,aAAA;EACA,sBAAA;AAicJ;;AA7bE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAgcJ;;AA7bE;EACE,YAAA;AAgcJ;;AA7bE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;AAgcJ;;AA9bE;EACE;IACE,WAAA;EAicJ;AACF","sourcesContent":["@import './colors.scss';\n@font-face {\n    font-family: 'Barlow';\n    src: url('../fonts/Barlow-Medium.ttf')\n  }\n  @font-face {\n    font-family: 'BarlowBold';\n    src: url('../fonts/Barlow-Bold.ttf')\n  }\n  @font-face {\n    font-family: 'BarlowSemiBold';\n    src: url('../fonts/Barlow-SemiBold.ttf')\n  }\n  @font-face {\n    font-family: 'BarlowRegular';\n    src: url('../fonts/Barlow-Regular.ttf')\n  }\nh1{\n    font-family: 'Barlow' !important;\n    font-size: 38px !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    line-height: normal !important; \n}\nh2{\n    font-family: 'Barlow' !important;\n    font-size: 34px !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    line-height: normal !important;\n}\nh3{\n    font-family: 'BarlowBold' !important;\n    font-size: 26px !important ;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    line-height: normal !important;  \n}\nh4{\n    font-family: 'BarlowBold' !important;\n    font-size: 22px !important ;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    line-height: normal !important;  \n}\nh5{\n    font-family: 'BarlowSemiBold' !important;\n    font-size: 18px !important ;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    line-height: normal !important;  \n}\np{\n    font-family: 'BarlowRegular' !important;\n    font-size: 16px  !important;\n    font-style: normal  !important;\n    font-weight: 400  !important;\n    line-height: normal  !important;\n}\n.mt-32{\n    margin-top: 32px !important;\n}\n.mt-24{\n    margin-top: 24px !important;\n}\n.mt-20{\n    margin-top:20px !important;\n}\n.mt-16{\n    margin-top: 16px !important;\n}\n.ml-16{\n    margin-left: 16px !important;\n}\n.px-20{\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n}\n.bl{\n    border-right: 1px solid #EAEAEA ;\n}\n.mt-12{\n    margin-top:12px !important;\n}\n.mt-10 {\n    margin-top: 10px;\n}\n.pr-5{\n    padding-right: 5px;\n}\n.mr-8{\n    margin-right: 8px !important;\n}\n.ml-8{\n    margin-left: 8px !important;\n}\n.ml-10{\n    margin-left: 10px;\n}\n.cta-qte{\n    background-color: rgba(0, 0, 0, 0.06) !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.42);\n    border-top: none !important;\n    border-right: none !important;\n    border-left: none !important;\n    min-width: 60px !important;\n    \n}\n.counter {\n    .MuiFormControl-root{\n         width:15% !important;\n    }\n    .MuiInputBase-root{\n        border-top-left-radius:0px !important;\n        border-radius: 0px !important;\n    }\n}\n.totale{\n    font-size: 16px;\n    font-family: \"Barlow\";\n    font-weight: 600;\n    color: rgba(18, 16, 16, 1);\n}\n.input-aug\n{\n    border-bottom:1px solid $text-color ;\n    // padding: 16px !important;\n    // height: 39px;\n    // border-top: none !important;\n    // border-right: none !important;\n    // border-left: none !important;\n    // background-color: $input-bg !important;\n    // border-radius: 2px 0 !important;\n}\n.input-aug div:hover{\n    background-color: rgba(228, 1, 21, 0.1) !important;\n    border-bottom:1px solid $primary-color !important;\n    \n}\n.input-aug:focus-within{\n    background-color: rgba(228, 1, 21, 0.24) !important;\n    border-bottom:1px solid $primary-color !important;\n\n}\n.css-2y464i-MuiInputBase-root-MuiFilledInput-root:before ,.css-1tzgnuz-MuiInputBase-root-MuiFilledInput-root:before{\n    //border-bottom: none  !important;\n}\n.css-2y464i-MuiInputBase-root-MuiFilledInput-root:after,.input-aug div::after,.input-aug div::before{\n    border-bottom: none !important;\n}\n.input-aug-filled{\n    border-bottom:1px solid $primary-color !important;\n}\n\n// .css-o943dk-MuiFormLabel-root-MuiInputLabel-root.Mui-focused{\n//     color:$primary-color !important;\n// }\n.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:after,\n .css-1ff8729-MuiInputBase-root-MuiFilledInput-root:before, \n .css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root:after\n , .css-1tzgnuz-MuiInputBase-root-MuiFilledInput-root:after{\n    border-bottom: none !important;\n}\n.css-2y464i-MuiInputBase-root-MuiFilledInput-root:hover,.css-1tzgnuz-MuiInputBase-root-MuiFilledInput-root:hover{\n    background-color: transparent !important;\n}\n.css-1tzgnuz-MuiInputBase-root-MuiFilledInput-root:hover:not(.Mui-disabled, .Mui-error):before{\n    border-bottom: none !important;\n}\n.css-2y464i-MuiInputBase-root-MuiFilledInput-root:hover:not(.Mui-disabled, .Mui-error):before{\n    border-bottom: none !important;\n}\n.css-10botns-MuiInputBase-input-MuiFilledInput-input, select, .input-aug div:before{\n    border-bottom:1px solid $text-color !important;\n}\n.css-10botns-MuiInputBase-input-MuiFilledInput-input:hover,.css-10botns-MuiInputBase-input-MuiFilledInput-input:focus , .css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root:focus,\n.css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root.Mui-focused{\n    border-bottom:1px solid $primary-color !important;\n}\n//.css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root\n.Mui-selected {\n    background-color: rgba(251, 38, 59, 1) !important;\n    color: white !important;\n    pointer-events: none !important;\n}\n.MuiMenuItem-root:hover {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    background-color: rgba(253, 230, 232, 1) !important;\n}\n.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:hover{\n    background-color: transparent !important;\n}\n\n.float-right{\n    float:right\n}\n.error-text, .error{\n    color: $error;\n    padding-top: 5px;\n}\nhr{\n    color:rgba(234, 234, 234, 1)!important;\n}\n\n.cta-retour{\n    text-decoration: none !important;\n    font-size: 16px;\n    font-family: \"Barlow\";\n    font-weight: 600;\n    color: $primary-color;\n}\n.cta-retour:hover{\n    text-decoration: none !important;\n    font-size: 16px;\n    font-family: \"Barlow\";\n    font-weight: 600;\n    color: $primary-color-hover;\n}\n.cta-retour:focus{\n    text-decoration: none !important;\n    font-size: 16px;\n    font-family: \"Barlow\";\n    font-weight: 600;\n    color: $primary-color-press;\n}\n.border-adresse{\n    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n    padding: 15px;\n    border-radius: 5px;\n}\n.min-vh-80{\n    min-height: 80vh;\n}\n.mt-48{\n    margin-top: 48px !important;\n}\n.open, .rotate180{\n    transform: rotate(-180deg);\n}\n.fitContent{\n    width: fit-content !important;\n}\n.d-column{\n    flex-direction: column !important;\n}\n.label-sort svg{\n    display: none !important;\n}\n.w-54{\n    width: 54px !important;\n}\n.right-aj {\n    display: inline-flex;\n    justify-content: right;\n    align-items: baseline;\n}\na {\n    text-decoration: none!important;\n}\n.table-photo {\n    width: 75px;\n    height: 75px;\n    border: 1px solid lightgray;\n    border-radius: 50%;\n    margin: 5px;\n}\n\n.cfvlby{\n    background-color: unset!important;\n    color: white\n}\n.rdt_TableHead {\n    background: #2D2A2C;\n}\n.action svg {\n    color: #FB263B;\n    margin-right: 15px;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n}\n.action svg:hover {\n    opacity: 0.7;\n}\n.action {\n    display: flex;\n}\n.dropzone {\n    width: 100%;\n    min-height: 250px;\n    background: whitesmoke;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n    border: 1px dashed gray;\n}\n.cadre svg {\n    position: absolute;\n    cursor: pointer;\n    color: #fb263b;\n}\n.MuiListItem-root{\n    cursor: pointer ;\n}\nbody {\n    //overflow-y: hidden;\n    //margin: 0; /* Remove default margin to prevent unwanted scrolling */\n  }\n .MuiTable-root{\n    overflow-y: auto;\n }\n .text-ref{\n    font-size: 14px !important;\n    font-family: \"Barlow\" !important;\n    font-weight: 400 !important;\n    color: rgba(125, 119, 121, 1) !important;\n }\n .ml-16{\n    margin-left: 16px !important;\n }\n .css-15v22id-MuiAccordionDetails-root{\n    padding: 0px !important;\n }\n .aug-table td{\n    padding: 0px 10px !important;\n }\n .aug-table th{\n    padding: 10px !important;\n }\n .lang-select{\n    background: transparent;\n    border: none;\n    border-bottom: none !important;\n    color: white;\n    font-size: 18px;\n    font-family: \"Barlow\";\n    font-weight: 600;\n    border:none !important;\n }","@use '../../assets/styles/colors.scss';\n@use '../../assets/styles/ui.scss';\n@use '../../assets/styles/btn.scss';\n$primary-color: #FB263B;\n$primary-color-hover: #ED4E5C;\n$primary-color-press: #F499A1;\n$interaction-dark-bg:#fff;\n$hover-dark-bg:#D5D4D5;\n$press-dark-bg:#969596;\n$light-bg:#F5F5F7;\n$dark-bg:#2D2A2C;\n$text-color:#121010;\n$subText-color:#7D7779;\n$success:#7BBE6A;\n$error:#7BBE6A;\n\n.left{\n    background-color: $dark-bg;\n    margin:48px !important;\n    min-height: 90vh;\n    background-image: url('../../assets/icons/Group285.svg');\n    background-repeat: no-repeat;\n    background-position: bottom;\n    background-size: contain;\n}\n.right{\n    min-height: 100vh;\n    position: relative;\n}\n.bloc{\n    width: 67%;\n    margin: auto;\n    padding-top: 10%;\n\n}\n.form-login{\n    margin: auto;\n    padding: 100px;\n    width: 90%;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n \n}\n\n.password-field {\n    display: flex;\n    flex-direction: column;\n \n  }\n  \n  .password-input-container {\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  \n  .password-input-container input {\n    flex-grow: 1;\n  }\n  \n  .password-input-container .password-icon {\n    position: absolute;\n    top: 50%;\n    right: 0.5rem;\n    transform: translateY(-50%);\n    cursor: pointer;\n  }\n  @media screen and (max-width:768px) {\n    .form-login{\n      width: 100%;\n    }\n  }","$primary-color: #FB263B;\n$primary-color-hover: #ED4E5C;\n$primary-color-press: #F499A1;\n$interaction-dark-bg:#fff;\n$hover-dark-bg:#D5D4D5;\n$press-dark-bg:#969596;\n$light-bg:#F5F5F7;\n$dark-bg:#2D2A2C;\n$text-color:#121010;\n$subText-color:#7D7779;\n$success:#7BBE6A;\n$error:#FF8A00;\n$input-bg:#FAFAFA;\n","@import './colors.scss';\n\n.btn-primary{\n    background-color: $primary-color;\n    border: 1px solid $primary-color;\n    color:#fff;\n    padding: 10px;\n    font-size:16px;\n    font-family: 'BarlowRegular';\n    font-weight: 600;\n    text-align: center;\n}\n.btn-primary:not(:disabled):hover{\n    background-color: $primary-color-hover;\n    border: 1px solid $primary-color-hover;\n\n}\n.btn-primary:not(:disabled):focus{\n    background-color: $primary-color-press;\n    border: 1px solid $primary-color-press;\n\n}\n.btn-secondary{\n    background-color: transparent;\n    border: 1px solid $primary-color;\n    color:$primary-color;\n    padding: 10px;\n    font-size:16px;\n    font-family: 'BarlowRegular';\n    font-weight: 600;\n    text-align: center;\n}\n.btn-secondary:not(:disabled):hover{\n    background-color: transparent;\n    border: 1px solid $primary-color-hover;\n    color:$primary-color-hover;\n   \n}\n.btn-secondary:not(:disabled):focus{\n    background-color: transparent;\n    border: 1px solid $primary-color-press;\n    color:$primary-color-press;\n   \n}\n.cta{\n    color: $primary-color;\n    background-color: transparent !important;\n    border: none !important;\n    text-align: center;\n    font-family: 'BarlowRegular';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-decoration: underline !important;\n}\n.cta:hover{\n    color: $primary-color-hover;\n}\n.cta:focus{\n    color: $primary-color-press;\n}\nbutton:disabled {\n    background-color: rgba(204, 205, 206, 1); /* Light grey */\n    border-color: rgba(204, 205, 206, 1) !important;\n    color: #fff; /* Dark grey */\n    cursor: not-allowed;\n  }\n  .cta:disabled{\n    color:rgba(204, 205, 206, 1) !important;\n  }\n  button:disabled {\n    background-color: rgba(204, 205, 206, 1); /* Light grey */\n    border-color: rgba(204, 205, 206, 1) !important;\n    color: #fff; /* Dark grey */\n    cursor: not-allowed;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
